export function formatActivityText(message = {}) {
  const type = message?.type;
  const payload = message?.payload || {};

  if (type === 'system') return message.message || null;

  if (type === 'transport_update' || type === 'transport_state_update') {
    const action = String(payload?.action || payload?.state?.last_action || '').toLowerCase();
    if (action === 'play') return 'Transport started';
    if (action === 'pause') return 'Transport paused';
    if (action === 'stop') return 'Transport stopped';
    return 'Transport updated';
  }

  if (type === 'track_lock_applied') {
    const label = payload?.objectType === 'clip' ? 'Clip locked' : 'Track parameter locked';
    const owner = payload?.lock?.lockedByName || 'collaborator';
    return `${label} by ${owner}`;
  }

  if (type === 'track_lock_denied' || type === 'track_update_denied' || type === 'session_update_denied') {
    const reason = String(payload?.reason || 'denied').replace(/_/g, ' ');
    return `Edit blocked (${reason})`;
  }

  if (type === 'undo_result' || type === 'redo_result') {
    const action = type === 'undo_result' ? 'Undo' : 'Redo';
    return payload?.ok === false ? `${action} failed` : `${action} applied`;
  }

  if (type === 'session_update') {
    const updateType = String(payload?.type || '');
    switch (updateType) {
      case 'timeline_clips_deleted':
        return `Deleted ${Array.isArray(payload?.clipIds) ? payload.clipIds.length : 0} clip(s)`;
      case 'timeline_clips_duplicated':
        return `Duplicated ${Array.isArray(payload?.clips) ? payload.clips.length : 0} clip(s)`;
      case 'timeline_clips_pasted':
        return `Pasted ${Array.isArray(payload?.clips) ? payload.clips.length : 0} clip(s)`;
      case 'timeline_clips_split':
        return `Split ${Array.isArray(payload?.clips) ? payload.clips.length : 0} clip(s)`;
      case 'timeline_clip_trimmed':
        return 'Trimmed clip';
      case 'timeline_clip_moved':
        return 'Moved clip';
      case 'track_added':
        return 'Added track';
      default:
        return null;
    }
  }

  return null;
}

export function shouldIncludeInActivityFeed(message = {}) {
  const ignored = new Set([
    'presence_update_event',
    'playhead_presence_update',
    'cursor_update',
    'cursor_hide',
    'presence_leave_event',
    'presence_heartbeat_event',
    'ownership_intent_update'
  ]);

  if (ignored.has(message?.type)) return false;
  return Boolean(formatActivityText(message));
}

export function buildActivityEntry(message = {}, nowMs = Date.now()) {
  if (!shouldIncludeInActivityFeed(message)) return null;
  return {
    id: `${nowMs}-${Math.random().toString(36).slice(2, 8)}`,
    text: formatActivityText(message),
    timestamp: Number(message?.timestamp || nowMs),
    sourceType: message?.type || 'unknown'
  };
}
